import { createSelector } from '@ngrx/store';
import { historyOrdersState } from '../root';

export const hasAnyHistoryOrder = createSelector(
    historyOrdersState,
    (historyOrders) =>
        historyOrders.orders.length > 0 && historyOrders.downloadedDate !== null
);
